'use strict';

const AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    EventEmitter = require('events').EventEmitter,
    { t } = require('services/i18nextWrapper'),
    ContextMenuEl = require('components/Commons/ContextMenuCustom/ContextMenuEl'),
    DashboardSpinnerEl = require('views/Dashboard/DashboardSpinnerHolder'),
    Constants = require('constants/AppConstants'),
    ActionTypes = Constants.ActionTypes,
    assign = require('object-assign'),
    Security = require('services/Security').auth,
    ChronologycServiceCache = require('services/ChronologycServiceCache'),
    DashboardLayoutStore = require('./DashboardLayoutStore'),
    SchedulerAppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    DashboardServiceImpl = require('services/DashboardServiceImpl'),
    DashboardCache = require('views/Dashboard/DashboardCache'),
    ChronologycStore = require('stores/ChronologycStore'),
    OrderUtils = require('utils/OrderUtils'),
    NumberUtils = require('utils/NumberUtils'),
    TankStore = require('stores/TankStore'),
    OrderStore = require('stores/OrderStore'),
    SessionStore = require('stores/SessionStore'),
    ContentUtils = require('utils/ContentUtils'),
    PositionUtils = require('utils/PositionUtils'),
    Notification = require('components/Notification/Notification'),
    DateUtils = require('utils/DateUtils'),
    DashboardAction = require('../actions/DashboardActionCreators'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    moment = require('moment'),
    CHANGE_EVENT = 'change',
    _ = require('lodash'),
    { DATE_FORMAT } = require('../constants/AppConstants');

const DashboardStore = assign({}, EventEmitter.prototype, {

    currentDate: moment(DATE_FORMAT),

    /**
     * Is the indicator about when is in progress the saving draft.
     */
    _isSavingDraft: false,

    /**
     * Is the indicator about when is already saved all draft operations.
     */
    _isSavedDraft: false,

    /**
     * Is the indicator about when is in progress the published draft.
     */
    _isPublishingDraft: false,

    /**
     * Is the indicator about when is already finish the publish.
     */
    _isPublishedDraft: false,

    /**
     * Indicate if has operation without publish.
     */
    _hasOperationWithoutPublish: false,

    /**
     * Force to render manually the Dashboard View from Store, this flag is here because we need to sync
     * from several places outside of Dashboard view when the dashboard need to be re-rendered.
     */
    _forceRenderDashboard: true,

    /**
     * This flag indicate when are in-progress dragging or resizing operation.
     */
    _isDraggingOrResizing: false,

    /**
     * This flag indicate when is needed load order out of range because we it on arrow blue dashboard options.
     */
    _triggerArrow: false,

    _isNeedCleanSelectedOrders: false,

    _contextMenuTemporaryDashboardLayout: null,

    _isInitializedLayoutDashboard: false,

    resetInitializedLayoutDashboard() {
        this._isInitializedLayoutDashboard = false;
    },

    isNeedCleanSelectedOrders() {
        return this._isNeedCleanSelectedOrders;
    },

    setNeedCleanSelectedOrders(isNeeded) {
        this._isNeedCleanSelectedOrders = isNeeded;
    },

    setInitializedLayoutDashboard() {
        this._isInitializedLayoutDashboard = true;
    },

    isInitializedLayoutDashboard() {
        return this._isInitializedLayoutDashboard;
    },

    getTemporaryContextMenuDashboardLayout() {
        return this._contextMenuTemporaryDashboardLayout;
    },

    setTemporaryContextMenuDashboardLayout(layout) {
        this._contextMenuTemporaryDashboardLayout = layout;
    },

    setIsCalculatingInventory(isCalculatingInventoryEnabled) {
        SessionStore.setIsCalculatingInventory(isCalculatingInventoryEnabled);
    },

    getIsCalculatingInventory() {
        return SessionStore.isCalculatingInventory();
    },

    /**
     * Indicate when the dashboard content is fetching.
     */
    isFetchingContent: false,

    formatAmountsTwoDigit(orders) {
        return orders.map(order => {
            OrderUtils.getAllProductsFromOrder(order).forEach(product => {
                product.amount = NumberUtils.formatDecimal(product.amount, 2);
                product.items = product.items && product.items.length ? product.items.map(item => {
                    item.amount = NumberUtils.formatDecimal(item.amount, 2);
                    return item;
                }) : [];
                product.volume = NumberUtils.formatDecimal(product.volume, 2);
                product.lastDiscountedAmount = NumberUtils.formatDecimal(product.lastDiscountedAmount, 2);
            });
            return order;
        });
    },

    /**
     * Fetch all the content need to render the whole dashboard page.
     * @param {Function} success
     * @param {Function} failure
     * @param failure
     */
    fetchDashboardContent(from, to, applicant, success, failure) {
        if (!this.isFetchingDashboardContent()) {
            this.setIsFetchingDashboardContent(true);

            this.resetInitializedLayoutDashboard();
            const self = this;

            let fetchDashboard = false;
            let fetchInventoryItems = false;
            let fetchInventoryProduct = false;

            // fetch orders and draft from scope
            DashboardServiceImpl.fetchNextDashboardContent(from, to, applicant, function () {
                const {
                    brewingNotes,
                    packagingNotes,
                    orders,
                    hasDraft,
                    draftOrderAmount,
                    undoDraftOrderAmount
                } = JSON.parse(this.response);

                // Indicate that has pending draft operation to publish
                DashboardStore.setHasOperationWithoutPublish(hasDraft);

                DashboardServiceImpl.fetchDashboardContent(function () {
                    const response = ContentUtils.parse(this.responseText);

                    if (response.applicantStatus === 'BLOCKED' || (SessionStore.isTrialVersion() && !SessionStore.isTrialVersionActive())) {
                        Security.logout();
                        window.location = process.env.URL_API + '/#/login?message=applicant_blocked';
                        return;
                    }
                    const sortedOrders = _sortOrdersChronologically(orders);
                    SessionStore.setCurrentLanguage(_.get(response, 'applicantConfigurationDetail.locale'));
                    DashboardServiceCache.fillCache(response);
                    DashboardServiceCache.setDraftOrderAmount(draftOrderAmount);
                    DashboardServiceCache.setUndoDraftOrderAmount(undoDraftOrderAmount);
                    DashboardServiceCache.fillCacheOrder(sortedOrders);
                    ChronologycServiceCache.setBrewingNotes(brewingNotes);
                    ChronologycServiceCache.setPackagingNotes(packagingNotes);

                    if (success) {
                        fetchDashboard = true;
                        onFinishFetchingAll({
                            onSuccess: success.bind(self),
                            fetchDashboard,
                            fetchInventoryItems,
                            fetchInventoryProduct
                        });
                    }
                }, () => {
                    if (failure) {
                        self.setIsFetchingDashboardContent(false);
                        failure();
                    }
                });

                DashboardServiceImpl.fetchDashboardInventoryItemsContent(function () {
                    const response = ContentUtils.parse(this.responseText);
                    DashboardServiceCache.fillCacheInventoryItems(response);

                    self.setIsFetchingDashboardContent(false);
                    if (success) {
                        fetchInventoryItems = true;
                        onFinishFetchingAll({
                            onSuccess: success.bind(self),
                            fetchDashboard,
                            fetchInventoryItems,
                            fetchInventoryProduct
                        });
                    }
                }, () => {
                    if (failure) {
                        self.setIsFetchingDashboardContent(false);
                        failure();
                    }
                });

                DashboardServiceImpl.fetchDashboardInventoryProductsContent(function () {
                    const response = ContentUtils.parse(this.responseText);
                    DashboardServiceCache.fillCacheInventoryProducts(response);

                    self.setIsFetchingDashboardContent(false);
                    if (success) {
                        fetchInventoryProduct = true;
                        onFinishFetchingAll({
                            onSuccess: success.bind(self),
                            fetchDashboard,
                            fetchInventoryItems,
                            fetchInventoryProduct
                        });
                    }
                }, () => {
                    if (failure) {
                        self.setIsFetchingDashboardContent(false);
                        failure();
                    }
                });
            });
        }
    },

    updateDashboardContent(onSuccess, onFailure) {
        DashboardServiceImpl.fetchDashboardContent(function () {
            const response = ContentUtils.parse(this.responseText);
            if (response.applicantStatus === 'BLOCKED') {
                Security.logout();
                window.location = process.env.URL_API + '/#/login?message=applicant_blocked';
                return;
            }
            DashboardServiceCache.fillCache(response);
            if (onSuccess) onSuccess();
        }, () => {
            if (onFailure) onFailure();
        });
    },

    setIsFetchingDashboardContent(isFetching) {
        this.isFetchingContent = isFetching;
    },

    isFetchingDashboardContent() {
        return this.isFetchingContent;
    },

    fetchDashboardContentCurrentRange() {
        const self = this;
        this.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), () => {
            self.forceRenderDashboard();
            self.emitChange();
        });
    },

    markAsSavedOperations(draft) {
        const operations = _.get(draft, 'operations');

        if (ContentUtils.isNotEmptyArray(operations)) {
            const updatedOperations = _.map(operations, operation => {
                operation.isSaved = true;
                return operation;
            });
            draft = _.set(draft, 'operations', updatedOperations);
        }

        return draft;
    },

    fetchNextDashboardContent(from, to, applicant, onSuccess, onFailure) {
        DashboardServiceImpl.fetchNextDashboardContent(from, to, applicant, onSuccess, onFailure);
    },

    isNeedForceRenderDashboard() {
        return this._forceRenderDashboard;
    },

    forceRenderDashboard() {
        this._forceRenderDashboard = true;
    },

    disabledForceRenderDashboard() {
        this._forceRenderDashboard = false;
    },

    setTriggerArrow() {
        this._triggerArrow = true;
    },

    unsetTriggerArrow() {
        this._triggerArrow = false;
    },

    isTriggerArrow() {
        return this._triggerArrow;
    },

    isPublishingDraft() {
        return this._isPublishingDraft;
    },

    setPublishingDraft() {
        this._isPublishingDraft = true;
    },

    unsetPublishingDraft() {
        this._isPublishingDraft = false;
    },

    isDraggingOrResizing() {
        return this._isDraggingOrResizing;
    },

    setDraggingOrResizing() {
        this._isDraggingOrResizing = true;
    },

    unsetDraggingOrResizing() {
        this._isDraggingOrResizing = false;
    },

    isPublishedDraft() {
        return this._isPublishedDraft;
    },

    setPublishedDraft() {
        this._isPublishedDraft = true;
    },

    setHasPendingSavedDraftWithoutPublish(hasPending) {
        SessionStore.setHasPendingSavedDraftWithoutPublish(hasPending);
    },

    hasPendingSavedDraftWithoutPublish() {
        return SessionStore.getHasPendingSavedDraftWithoutPublish() ||
            DashboardServiceCache.getPendingOperations().length > 0;
    },

    hasOperationWithoutPublish() {
        // ask first for flag because when initial fetching
        // that flag is assigned by a flag from backend side.
        return this._hasOperationWithoutPublish ||
            DashboardServiceCache.getOperations().length > 0;
    },

    setHasOperationWithoutPublish(hasOperation) {
        this._hasOperationWithoutPublish = hasOperation;
    },

    unsetPublishedDraft() {
        this._isPublishedDraft = false;
    },

    setIsSavingDraft() {
        this._isSavingDraft = true;
    },

    unsetIsSavingDraft() {
        this._isSavingDraft = false;
    },

    isSavingDraft() {
        return this._isSavingDraft;
    },

    setIsSavedDraft() {
        this._isSavedDraft = true;
    },

    unsetIsSavedDraft() {
        this._isSavedDraft = false;
    },

    isSavedDraft() {
        return this._isSavedDraft;
    },

    /**
     * Publish the current draft against to the server in order to be available all the orders changes, such as new order,
     * changes and deletes, for the rest of the user of the applicant. After that will be deleted the current draft and notify.
     * And finally will be available a new version of dashboard, in order to get the last changes for the rest of the users.
     */
    publishDraft() {
        DashboardServiceImpl.publishDraft(() => {
            DashboardAction.publishingSuccess();
        }, () => {
            DashboardAction.publishingFailure();
        });
    },

    undoDraft() {
        DashboardServiceImpl.undoDraft(() => {
            DashboardAction.undoDraftSuccess();
        }, () => {
            DashboardAction.undoDraftFailure();
        });
    },

    redoDraft() {
        DashboardServiceImpl.redoDraft(() => {
            DashboardAction.redoDraftSuccess();
        }, () => {
            DashboardAction.redoDraftFailure();
        });
    },

    getTankFromClientX(clientX) {
        const tanks = TankStore.getTanks();
        const tankSelectedId = PositionUtils.getHeaderTankClickedId(clientX);
        return _.find(tanks, tank => String(tank.id) == tankSelectedId);
    },

    getTankFromColumnTankEl(columTank) {
        const tanks = TankStore.getTanks();
        const tankSelectedId = columTank.getAttribute('data-tank-id');
        return _.find(tanks, tank => String(tank.id) == tankSelectedId);
    },


    _getTankHeader(clientX) {
        let tryToSearch = 50;
        let trying = -1;
        let target;
        let increase = 5;
        const startingPoint = SessionStore.getHeaderHigh();

        while (trying < tryToSearch) {
            trying++;
            const targetY = startingPoint + (increase * trying);
            //console.log('Trying to find a column at position Y: [' + targetY + ']');
            target = PositionUtils.elementFromPoint(clientX, targetY);
            if (target && (target.classList.contains('fixed-header') || target.classList.contains('fixed-header-tank-name'))) {
                //console.log('Column founded at position Y: [' + targetY + ']');
                return target;
            }
        }
        return null;
    },

    emitChange() {
        this.emit(CHANGE_EVENT);
    },

    isOutsideOfDashboard(dashboardFrom, dashboardTo, orderToValidate) {
        if (DateUtils.isBefore(orderToValidate.brewDate, dashboardFrom) || DateUtils.isAfter(orderToValidate.orderDate, dashboardTo)) {
            return true;
        }
        return false;
    },

    isOutsideSingleOfDashboard(dashboardFrom, dashboardTo, orderToValidate) {
        if (DateUtils.isBefore(orderToValidate.fromDate, dashboardFrom) || DateUtils.isAfter(orderToValidate.toDate, dashboardTo)) {
            return true;
        }
        return false;
    },

    setLayoutWithoutHydrated(layout) {
        DashboardLayoutStore.setLayout(layout);
    },

    setLayout(layout, from = ChronologycStore.getCurrentFrom(), to = ChronologycStore.getCurrentTo()) {
        DashboardLayoutStore.setLayout(OrderStore.hydrateOrdersOutOfRange(layout, from, to));
    },

    cleanLayout() {
        DashboardLayoutStore.cleanLayout();
    },

    getLayout() {
        return DashboardLayoutStore.getLayout();
    },

    removeChangeListener(call) {
        this.removeListener(CHANGE_EVENT, call);
    },

    addChangeListener(call) {
        this.on(CHANGE_EVENT, call);
    },

    setCurrentDate(date) {
        this.currentDate = date;
    },

    //TODO: testing propose
    addBeerStyles(beerStyles) {
        DashboardServiceCache._setBeerStyles(beerStyles);
    }
});

function onFinishFetchingAll({
    onSuccess,
    fetchDashboard,
    fetchInventoryItems,
    fetchInventoryProduct
}) {
    if (fetchDashboard && fetchInventoryItems && fetchInventoryProduct) {
        onSuccess();
    }
}

function _buildMenuItemsBrewhouse(action, order) {
    if (order) {
        return _buildChangeOrderFromBrewhouseMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType);
    }
}

function _buildMenuItemsGuest(action, order) {
    if (order) {
        return _buildChangeOrderFromGuestMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType);
    }
}

function _buildMenuItems(action, order) {
    if (order) {
        return _buildChangeOrderMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType, action.tankClicked);
    } else {
        return _buildNewOrderMenuItems(action.dateClicked, action.tankClicked);
    }
}

function _buildChangeOrderMenuItems(orderSelected, dateRow, isFermenterTank, tankType, tankClicked) {

    return [
        {
            icon: 'settings',
            text: t('dashboard_store_text_edit_order'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
                    existingOrderInfo: {
                        openGeneralTab: true,
                        orderSelected,
                        dateRow,
                        isFermenterTank,
                        tankType
                    }
                });
            }
        },
        {
            icon: 'border_color',
            text: t('dashboard_store_text_edit_day'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_CHANGE_TASK_ORDER_DASHBOARD,
                    existingOrderInfo: {
                        openGeneralTab: false,
                        orderSelected,
                        dateRow,
                        isFermenterTank,
                        tankType
                    }
                });
            }
        },
        { isDivider: true },
        {
            icon: 'vertical_align_top',
            text: t('dashboard_store_text_insert_day_above'),
            onClick: evt => {
                evt.preventDefault();
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_ABOVE,
                    dateClicked: dateRow,
                    order: orderSelected,
                    tankClicked
                });
            }
        },
        {
            icon: 'vertical_align_bottom',
            text: t('dashboard_store_text_insert_day_below'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_BELOW,
                    dateClicked: dateRow,
                    order: orderSelected,
                    tankClicked
                });
            }
        },
        { isDivider: true },
        {
            icon: 'arrow_upward',
            text: t('dashboard_store_text_move_day_before'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE,
                    dateClicked: dateRow,
                    order: orderSelected,
                    tankClicked
                });
            }
        },
        {
            icon: 'arrow_downward',
            text: t('dashboard_store_text_move_day_after'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_AFTER,
                    dateClicked: dateRow,
                    order: orderSelected,
                    tankClicked
                });
            }
        },
        { isDivider: true },
        {
            icon: 'exposure_neg_1',
            text: t('dashboard_store_text_delete_day'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_REMOVE_DAY_ORDER,
                    dateClicked: dateRow,
                    order: orderSelected,
                    tankClicked
                });
            }
        },
        {
            icon: 'delete',
            text: t('dashboard_store_text_delete_order'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
                    order: orderSelected
                });
            }
        }
    ];

}


function _buildChangeOrderFromGuestMenuItems(orderSelected, dateRow, isFermenterTank, tankType) {
    return [
        {
            icon: 'visibility',
            text: t('dashboard_store_text_show_order'),
            onClick: () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
                    existingOrderInfo: {
                        openGeneralTab: true,
                        orderSelected,
                        dateRow,
                        isFermenterTank,
                        tankType
                    }
                });
            }
        }];
}

function _buildChangeOrderFromBrewhouseMenuItems(orderSelected, dateRow, isFermenterTank, tankType) {

    return ContentUtils.isGhostOrder(orderSelected) ?
        // Ghost Order
        [
            {
                icon: 'delete',
                text: t('dashboard_store_text_delete_order'),
                onClick: () => {
                    AppDispatcher.dispatch({
                        type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
                        order: orderSelected
                    });
                }
            }
        ]

        :
        // Non Ghost Order
        [
            {
                icon: 'settings',
                text: t('dashboard_store_text_edit_order'),
                onClick: () => {
                    AppDispatcher.dispatch({
                        type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
                        existingOrderInfo: {
                            openGeneralTab: true,
                            orderSelected,
                            dateRow,
                            isFermenterTank,
                            tankType
                        }
                    });
                }
            },
            {
                icon: 'delete',
                text: t('dashboard_store_text_delete_order'),
                onClick: () => {
                    AppDispatcher.dispatch({
                        type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
                        order: orderSelected
                    });
                }
            }
        ];
}

function _buildNewOrderMenuItems(dateClicked, tankSelected) {
    return [
        {
            icon: 'add_circle_outline',
            text: t('dashboard_store_text_create_order'),
            onClick: () => {
                const preDefinedOrder = {
                    date: dateClicked,
                    tankSelected,
                    tankType: _.get(tankSelected, 'type')
                };

                AppDispatcher.dispatch({
                    type: ActionTypes.CONTEXT_MENU_NEW_ORDER_DASHBOARD,
                    preDefinedOrder
                });
            }
        }
    ];
}

/*
 Jero: This method will create here, because when we need to show immediately
 spinner on dashboard we could not fire an event to perform this function body.
 */
function savingDraft() {
    DashboardStore.setIsSavingDraft();
    DashboardStore.unsetIsSavedDraft();
    DashboardStore.emitChange();
    DashboardStore.forceRenderDashboard();
}

function getAmountDaysDuration(tankType, order) {
    const startDate = ContentUtils.getOrderField(order, 'startDate', tankType);
    const endDate = ContentUtils.getOrderField(order, 'endDate', tankType);
    return DateUtils.getDaysBetween(startDate, endDate) + 1; // add one day to
}

DashboardStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
    switch (action.type) {
        case ActionTypes.RIGHT_CLICK_DASHBOARD: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            if (SessionStore.isAbleToEditDates()) {
                const menuItems = _buildMenuItems(action);
                const textDisplayDate = DateUtils.toDisplayDateText(action.dateClicked);
                const textDisplaySubtitleDate = (new Date()).getFullYear(); // current year
                DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
                ContextMenuEl.show(
                    action.positionX,
                    action.positionY,
                    textDisplayDate,
                    textDisplaySubtitleDate,
                    menuItems
                );
            } else {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
            }
            break;
        }

        case ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            let menuItemsFromOrder;
            const targetOrder = _.find(OrderStore.getOrders(), order => order.id === action.orderId);
            const brewingTank = _.get(action, 'tankType') === 'BH';

            if (!SessionStore.isAdminUser()) {
                menuItemsFromOrder = _buildMenuItemsGuest(action, targetOrder);
            } else if (brewingTank) {
                menuItemsFromOrder = _buildMenuItemsBrewhouse(action, targetOrder);
            } else {
                menuItemsFromOrder = _buildMenuItems(action, targetOrder);
            }

            const dayDuration = getAmountDaysDuration(action.tankType, targetOrder);

            const textDisplayDate = DateUtils.toDisplayDateTextShort(action.dateClicked);
            const beerStyleName = _.get(targetOrder, 'styleBeer.name');
            const displayText = `${textDisplayDate} - Batch: ${action.batchNumber} - Days: ${dayDuration}`;

            DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
            ContextMenuEl.show(
                action.positionX,
                action.positionY,
                displayText,
                beerStyleName,
                menuItemsFromOrder
            );
            break;
        }

        case ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            const targetOrderBH = _.find(OrderStore.getOrders(), order => order.id === _.get(action, 'order.id'));
            const menuItemsFromOrderBH = _buildMenuItemsBrewhouse(action, targetOrderBH);
            DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
            const textDisplayDate = DateUtils.toDisplayDateText(action.dateClicked);
            const beerStyleName = _.get(targetOrderBH, 'styleBeer.name');
            const displayText = `${textDisplayDate} - Batch: ${action.batchNumber}`;
            ContextMenuEl.show(
                action.positionX,
                action.positionY,
                displayText,
                beerStyleName,
                menuItemsFromOrderBH
            );
        }

        case ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_BELOW:
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            if (OrderUtils.haveSomeProductConfirmedFromOrderAfterDate(action.order, action.dateClicked)) {
                Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
                return;
            }
            if (!SessionStore.isAbleToEditDates()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }
            // Check if Fermenting and Packaging day have space
            if (OrderStore.addOneDayBelow(action.order, action.tankClicked, action.dateClicked)) {
                Notification.show(t('dashboard_notification_one_day_added'), 'success');
                DashboardStore.emitChange();
            }

            ContextMenuEl.close();
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
            savingDraft();
            DashboardStore.emitChange();
            break;

        case ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_ABOVE: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            if (OrderUtils.haveSomeProductConfirmedFromOrderAfterOrEqualDate(action.order, action.dateClicked)) {
                Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
                return;
            }
            if (!SessionStore.isAbleToEditDates()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }

            // Check if Fermenting and Packaging day have space
            if (OrderStore.addOneDayAbove(action.order, action.tankClicked, action.dateClicked)) {
                Notification.show(t('dashboard_notification_one_day_added'), 'success');
                DashboardStore.emitChange();
            }
            ContextMenuEl.close();
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
            savingDraft();
            DashboardStore.emitChange();
            break;
        }

        case ActionTypes.CONTEXT_MENU_REMOVE_DAY_ORDER: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            if (OrderUtils.haveSomeProductConfirmedFromOrderAfterOrEqualDate(action.order, action.dateClicked)) {
                Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
                return;
            }
            if (!SessionStore.isAbleToEditDates()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }

            // Check in case of combined order, the packaging tank if can move up and have space.
            CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_day'), () => {
                if (OrderStore.removeOneDay(action.order, action.tankClicked, action.dateClicked)) {
                    Notification.show(t('dashboard_notification_day_has_been_deleted'), 'success');
                    DashboardStore.forceRenderDashboard();
                    DashboardStore.emitChange();
                }
            });
            ContextMenuEl.close();
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
            savingDraft();
            DashboardStore.emitChange();
            break;
        }

        case ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }

            if (!OrderUtils.isAbleToMoveTaskADayBefore(action.order, action.dateClicked, action.tankClicked)) {
                Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
                return;
            }

            if (!SessionStore.isAdminUser()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }

            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));

            if (OrderStore.moveTask(action.order, action.tankClicked, action.dateClicked, -1)) {
                Notification.show(t('dashboard_notification_day_has_been_moved'), 'success');
                DashboardStore.emitChange();
            }
            ContextMenuEl.close();
            savingDraft();
            DashboardStore.emitChange();
            break;
        }

        case ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_AFTER: {
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }

            if (!OrderUtils.isAbleToMoveTaskADayAfter(action.order, action.dateClicked, action.tankClicked)) {
                Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
                return;
            }

            if (!SessionStore.isAdminUser()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }

            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));

            if (OrderStore.moveTask(action.order, action.tankClicked, action.dateClicked, 1)) {
                Notification.show(t('dashboard_notification_day_has_been_moved'), 'success');
                DashboardStore.emitChange();
            }
            ContextMenuEl.close();
            savingDraft();
            DashboardStore.emitChange();
            break;
        }

        case ActionTypes.FORCE_MANUAL_DRAWING_DASHBOARD: {
            if (!DashboardStore.isPublishingDraft()) {
                // enter here means it's saving draft finished
                DashboardStore.forceRenderDashboard();
                DashboardStore.emitChange();
            }
            break;
        }
        case ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD: {
            if (!DashboardStore.isSavingDraft() && !DashboardStore.isPublishingDraft()) {
                // enter here means it's saving draft finished
                DashboardStore.setNeedCleanSelectedOrders(true);
                OrderStore.updateLastOrderUpdated(null);
                DashboardStore.forceRenderDashboard();
                DashboardStore.emitChange();
            }
            break;
        }

        case ActionTypes.FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD: {
            DashboardStore.fetchDashboardContent(action.from, action.to, SessionStore.getCurrentApplicant(), () => {
                DashboardStore.forceRenderDashboard();
                DashboardStore.emitChange();
                window.location.reload(true);
            });
            break;
        }

        case ActionTypes.PERFORM_BATCH_OPERATION_END:
            DashboardLayoutStore.resetAllPositionAsRelocatedDone(action.batchNumber);
            break;

        case ActionTypes.CONTEXT_MENU_REMOVE_ORDER:
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            if (!SessionStore.isAbleToEditDates()) {
                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
                return;
            }
            const orderHasSomeConfirmedProduct = OrderUtils.haveSomeProductConfirmedFromOrder(action.order);
            CustomDialog.showWarningConfirmation(t('warning'), orderHasSomeConfirmedProduct ? t('notification_confirm_delete_orden_and _return_inventory') : t('notification_confirm_delete_orden'), () => {
                OrderStore.removeOrder(action.order);
                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
                DashboardStore.forceRenderDashboard();
                ContextMenuEl.close();
                DashboardStore.setIsSavingDraft();
                DashboardStore.emitChange();
            });
            ContextMenuEl.close();
            DashboardStore.emitChange();
            break;

        case ActionTypes.DASHBOARD_MODAL_CLOSE_MODAL:
            DashboardStore.emitChange();
            break;
        case ActionTypes.OPEN_DAY_NOTES:
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            break;

        case ActionTypes.CLOSE_DAY_NOTES:
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            break;

        case ActionTypes.NEW_VERSION_API:
            DashboardCache.cleanCache();
            DashboardServiceCache.clearAllCache();
            window.location.reload(true); // reload all again from the server.
            break;

        case ActionTypes.SAVE_CONFIGURATION_SETTINGS:
            // A hack to get the page to stop reloading
            const lastConfigurationForceReload = window.localStorage.getItem('lastConfigurationForceReload');
            if (lastConfigurationForceReload) {
                if ((new Date().getTime()) - lastConfigurationForceReload < 60000) {
                    return;
                }
            }
            
            window.localStorage.setItem('lastConfigurationForceReload', new Date().getTime());
            window.location.reload(true); // reload all again from the server.
            break;

        case ActionTypes.NEW_ORDER:
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
            OrderStore.updateLastOrderUpdated(action.order);
            DashboardStore.forceRenderDashboard();
            DashboardStore.setIsSavingDraft();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();

            break;

        case ActionTypes.CHANGE_ORDER:
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
            OrderStore.updateLastOrderUpdated(action.order);
            DashboardStore.forceRenderDashboard();
            DashboardStore.setIsSavingDraft();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.REMOVED_ORDER:
            if (DashboardStore.isPublishingDraft()) {
                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
                return;
            }
            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
            DashboardStore.forceRenderDashboard();
            DashboardStore.setIsSavingDraft();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.NEW_ORDER_DRAFT:
            DashboardStore.setIsSavingDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.CHANGE_ORDER_DRAFT:
            DashboardStore.setIsSavingDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.REMOVED_ORDER_DRAFT:
            DashboardStore.setIsSavingDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.PUBLISHING_CHANGE_ADMIN_DRAFT: {
            DashboardStore.setIsSavingDraft();
            DashboardSpinnerEl.show();
            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), () => {
                DashboardStore.forceRenderDashboard();
                ChronologycStore.emitChange();
                DashboardStore.emitChange();
                DashboardSpinnerEl.hide();
            });
            break;
        }

        case ActionTypes.SAVE_DRAFT:
            // enter here when at level of server side is in-progress draft saving
            DashboardStore.setIsSavingDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.SHOW_LOADING:
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.HIDE_LOADING:
            DashboardSpinnerEl.hide();
            break;

        case ActionTypes.SAVE_DRAFT_SUCCESS:
            // enter here when at level of server side is draft already saved
            if (DashboardServiceCache.isAllOperationAlreadySaved() && !DashboardStore.isDraggingOrResizing()) {
                // enter here only if don't have any non saved operation, because is still pending
                // some non-saved operation wait to DraftSavedPoll save for us.
                DashboardServiceCache.setUndoDraftOrderAmount(0);
                DashboardStore.unsetIsSavingDraft();
                DashboardSpinnerEl.hide();
                DashboardStore.setIsSavedDraft();
                DashboardStore.forceRenderDashboard();
                DashboardStore.emitChange();
                DashboardStore.setHasPendingSavedDraftWithoutPublish(DashboardStore.hasPendingSavedDraftWithoutPublish());
            } else {
                DashboardSpinnerEl.show();
            }
            break;

        case ActionTypes.SAVE_DRAFT_FAILURE:
            DashboardStore.unsetIsSavingDraft();
            DashboardStore.unsetIsSavedDraft();
            break;

        case ActionTypes.UNDO_DRAFT:
            DashboardSpinnerEl.show();
            DashboardStore.setIsSavingDraft();
            DashboardStore.undoDraft();
            DashboardStore.emitChange();
            DashboardStore.forceRenderDashboard();
            break;

        case ActionTypes.UNDO_DRAFT_SUCCESS:
            DashboardStore.unsetIsSavedDraft();
            DashboardStore.emitChange();
            DashboardStore.forceRenderDashboard();

            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), () => {
                DashboardServiceCache.cleanOperations();
                DashboardStore.forceRenderDashboard();
                DashboardStore.unsetIsSavingDraft();
                ChronologycStore.emitChange();
                DashboardStore.emitChange();
                DashboardSpinnerEl.hide();
                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
            });
            break;

        case ActionTypes.REDO_DRAFT:
            DashboardSpinnerEl.show();
            DashboardStore.setIsSavingDraft();
            DashboardStore.redoDraft();
            DashboardStore.forceRenderDashboard();
            break;

        case ActionTypes.REDO_DRAFT_SUCCESS:
            DashboardStore.unsetIsSavedDraft();
            DashboardStore.emitChange();
            DashboardStore.forceRenderDashboard();

            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), () => {
                DashboardServiceCache.cleanOperations();
                DashboardStore.forceRenderDashboard();
                DashboardStore.unsetIsSavingDraft();
                ChronologycStore.emitChange();
                DashboardStore.emitChange();
                DashboardSpinnerEl.hide();
                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
            });
            break;

        case ActionTypes.PUBLISHING_DRAFT:
            DashboardStore.emitChange();
            DashboardStore.publishDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.setIsSavingDraft();
            DashboardStore.setPublishingDraft();
            DashboardSpinnerEl.show();
            break;

        case ActionTypes.FINISH_TO_DRAGGING_OR_RESIZING:
            if (!DashboardStore.isSavingDraft() && !DashboardStore.isPublishingDraft()) {
                DashboardStore.emitChange();
            }
            break;


        case ActionTypes.PUBLISHING_DRAFT_SUCCESS:
            DashboardStore.setPublishedDraft();
            DashboardStore.unsetPublishingDraft();
            DashboardStore.setHasPendingSavedDraftWithoutPublish(DashboardServiceCache.getPendingOperations().length > 0);
            DashboardStore.setHasOperationWithoutPublish(DashboardServiceCache.getOperations().length > 0);
            DashboardStore.forceRenderDashboard();

            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), () => {
                DashboardServiceCache.cleanOperations();
                DashboardStore.forceRenderDashboard();
                DashboardStore.unsetIsSavingDraft();
                ChronologycStore.emitChange();
                DashboardStore.emitChange();
                DashboardSpinnerEl.hide();
                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
            });
            break;

        case ActionTypes.PUBLISHING_DRAFT_FAILURE:
            DashboardStore.unsetPublishingDraft();
            DashboardStore.unsetPublishedDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.hide();
            Notification.show(t('dashboard_notification_something_was_wrong'));
            break;

        case ActionTypes.UNDO_DRAFT_FAILURE:
            DashboardStore.unsetPublishingDraft();
            DashboardStore.unsetPublishedDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.hide();
            Notification.show(t('dashboard_notification_something_was_wrong'));
            break;

        case ActionTypes.REDO_DRAFT_FAILURE:
            DashboardStore.unsetPublishingDraft();
            DashboardStore.unsetPublishedDraft();
            DashboardStore.forceRenderDashboard();
            DashboardStore.emitChange();
            DashboardSpinnerEl.hide();
            Notification.show(t('dashboard_notification_something_was_wrong'));
            break;

        default:
    }

});


function _sortOrdersChronologically(orders) {
    return (orders || []).sort((order, orderCompare) => {
        let field;

        if (order.isSingle) {
            field = 'fromDate';
        } else {
            field = 'brewDate';
        }

        if (DateUtils.isAfter(order[field], orderCompare[field])) {
            return 1;
        }
        if (DateUtils.isBefore(order[field], orderCompare[field])) {
            return -1;
        }
        return 0;
    });
}

module.exports = DashboardStore;



/** WEBPACK FOOTER **
 ** ./src/stores/DashboardStore.js
 **/